import React from 'react';
import styled from 'styled-components';

const Photos = styled.img`
  width: 100%;
  border: 1px solid #dedede;
  border-radius: 3px;
`;

const Button = styled.button`
  background-color: #ffffff;
  font-size: 2em;
  margin: 0.5em 0.25em;
  padding: 0em 0.5em;
  border: 1px solid #c7c7c7;
  border-radius: 3px;

  &:hover {
    background-color: #c7c7c7c7;
  }

  &:focus {
      outline:none;
  }
`;


class MediaFrame extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      picture: this.props.pictures[0]
    };
    this.changePic = this.changePic.bind(this);
    this.idx = 0;
  }

  changePic(direction) {
    if (direction > 0) {
      this.idx += 1 ;
      if (this.idx >= this.props.pictures.length) {
        this.idx = 0;
      }
    } else {
      this.idx -= 1;
      if (this.idx < 0) {
        this.idx = this.props.pictures.length - 1;
      }
    }

    this.setState({
      picture: this.props.pictures[this.idx]
    })
  }

  render() {
    return (
      <div>
        <p>{this.props.desc}</p>
        {this.props.links ?
          <a target='_blank' href={this.props.links[this.idx]}><Photos src={this.state.picture}></Photos></a> :
          <Photos src={this.state.picture}></Photos>
        }
        <div style={{textAlign: 'center'}}>
        <Button onClick={this.changePic.bind(this, -1)}> 👈 </Button>
        <Button onClick={this.changePic.bind(this, 1)}> 👉 </Button>
        </div>
      </div>
    );
  }
}

export default MediaFrame;


// WEBPACK FOOTER //
// ./src/components/MediaFrame.js